import { i as r } from "./is-object.js";
import { c as e } from "./create-non-enumerable-property.js";
var a = function a(_a, s) {
  r(s) && "cause" in s && e(_a, "cause", s.cause);
};
export { a as i };